import React, {useState } from "react";
import { Button } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

function TrialHeader({ searchCallback }) {
  const [startDate, setStartDate] = useState(new Date());

  const handleStartDate = (event) => {
    setStartDate(event);
  };

  const handleSearch = () => {
    searchCallback(startDate);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        marginTop:'20vh'
      }}
    >
      <lebel style={{ width: "200px" }}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            size="small"
            label="Ledger Start Date"
            value={startDate}
            onChange={(event) => handleStartDate(event)}
            disableFuture
            InputProps={{ disableUnderline: true }}
          />
        </LocalizationProvider>
      </lebel>

      <Button
        style={{
          backgroundColor: "#379683",
          color: "white",
          marginTop: 3,
          width: '200px',
        }}
        onClick={handleSearch}
      >
        Search
      </Button>
    </div>
  );
}

export default TrialHeader;
